module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/desenrola2x-88840ab52ab4bbf41b701eafc747d73e.webp";